import React, { useEffect, useState } from 'react';
import { IconButton, TextField } from '@mui/material';
import EditNoteIcon from '@mui/icons-material/EditNote';
import ActionDialog from '../dialog/ActionDialog';
import theme from '../../theme';
import { useError } from '../../contexts/ErrorContext';

const RECOMMENDATION_COMMENT_MAX_LENGTH = 150;

const RecommendedAlbumCommentButton = ({ albumInfo, onUpdate }) => {
  const [open, setOpen] = useState(false);
  const [recommendationComment, setRecommendationComment] = useState(
    albumInfo?.recommendationComment || '',
  );
  const [recommendationCommentEn, setRecommendationCommentEn] = useState(
    albumInfo?.recommendationCommentEn || '',
  );
  const { showError } = useError();

  useEffect(() => {
    setRecommendationComment(albumInfo?.recommendationComment || '');
    setRecommendationCommentEn(albumInfo?.recommendationCommentEn || '');
  }, [albumInfo?.id, albumInfo?.recommendationComment, albumInfo?.recommendationCommentEn]);

  const handleConfirm = () => {
    if (
      recommendationComment.length > RECOMMENDATION_COMMENT_MAX_LENGTH ||
      recommendationCommentEn.length > RECOMMENDATION_COMMENT_MAX_LENGTH
    ) {
      showError('150자 이내로 작성해주세요.');
      return;
    }
    onUpdate?.(recommendationComment, recommendationCommentEn);
    setOpen(false);
  };

  return (
    <>
      <IconButton
        disableRipple
        onClick={() => setOpen(true)}
        aria-label="edit recommended album comment"
        sx={{
          width: { xs: 32, md: 40 },
          height: { xs: 32, md: 40 },
          p: 1,
          border: `1px solid ${theme.palette.grey.line}`,
          borderRadius: 1,
        }}
      >
        <EditNoteIcon
          sx={{
            width: { xs: 18, md: 26 },
            height: { xs: 18, md: 26 },
            color: theme.palette.black[4],
          }}
        />
      </IconButton>
      <ActionDialog
        open={open}
        onClose={() => setOpen(false)}
        onConfirm={handleConfirm}
        title="앨범 노트 작성"
        confirmText="저장"
      >
        <TextField
          autoFocus
          fullWidth
          multiline
          minRows={4}
          value={recommendationComment}
          onChange={(event) => setRecommendationComment(event.target.value)}
          placeholder="앨범 상세에 노출할 앨범 노트를 입력하세요."
          helperText={`${recommendationComment.length}/${RECOMMENDATION_COMMENT_MAX_LENGTH}`}
          error={recommendationComment.length > RECOMMENDATION_COMMENT_MAX_LENGTH}
        />
        <TextField
          fullWidth
          multiline
          minRows={4}
          value={recommendationCommentEn}
          onChange={(event) => setRecommendationCommentEn(event.target.value)}
          placeholder="영문 앨범 노트 (선택 · 비워두면 한국어 표시)"
          helperText={`${recommendationCommentEn.length}/${RECOMMENDATION_COMMENT_MAX_LENGTH}`}
          error={recommendationCommentEn.length > RECOMMENDATION_COMMENT_MAX_LENGTH}
          sx={{ mt: 2 }}
        />
      </ActionDialog>
    </>
  );
};

export default RecommendedAlbumCommentButton;
